import { render, staticRenderFns } from "./visualizarexame.vue?vue&type=template&id=4d1b291f&"
import script from "./visualizarexame.vue?vue&type=script&lang=js&"
export * from "./visualizarexame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports